import { motion } from 'framer-motion';

const ProfilePreview = ({ currentData, newData, isVisible }) => {
  if (!isVisible) return null;

  const hasChanges = () => {
    return (
      currentData.name !== newData.name ||
      currentData.email !== newData.email ||
      currentData.phone !== newData.phone
    );
  };

  if (!hasChanges()) return null;

  return (
    <motion.div
      initial={{ opacity: 0, height: 0 }}
      animate={{ opacity: 1, height: 'auto' }}
      exit={{ opacity: 0, height: 0 }}
      className="mt-4 p-4 bg-blue-50 rounded-xl border border-blue-200"
    >
      <h4 className="text-sm font-semibold text-blue-800 mb-3 flex items-center">
        <i className="fas fa-eye mr-2"></i>
        Preview Changes
      </h4>
      
      <div className="space-y-2 text-sm">
        {currentData.name !== newData.name && (
          <div className="flex justify-between">
            <span className="text-gray-600">Name:</span>
            <div className="text-right">
              <div className="line-through text-red-500">{currentData.name}</div>
              <div className="text-green-600 font-medium">{newData.name}</div>
            </div>
          </div>
        )}
        
        {currentData.email !== newData.email && (
          <div className="flex justify-between">
            <span className="text-gray-600">Email:</span>
            <div className="text-right">
              <div className="line-through text-red-500">{currentData.email}</div>
              <div className="text-green-600 font-medium">{newData.email}</div>
            </div>
          </div>
        )}
        
        {currentData.phone !== newData.phone && (
          <div className="flex justify-between">
            <span className="text-gray-600">Phone:</span>
            <div className="text-right">
              <div className="line-through text-red-500">{currentData.phone}</div>
              <div className="text-green-600 font-medium">{newData.phone}</div>
            </div>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default ProfilePreview;